module.exports = __webpack_public_path__ + "assets/img/eternia-30.09ffdfa6.jpg";